import type { ReactNode } from 'react';
import type { Portal } from '@/routes/roles';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import DirectionsBusOutlinedIcon from '@mui/icons-material/DirectionsBusOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import GradingOutlinedIcon from '@mui/icons-material/GradingOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import CalendarViewWeekOutlinedIcon from '@mui/icons-material/CalendarViewWeekOutlined';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined';
import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import SportsSoccerOutlinedIcon from '@mui/icons-material/SportsSoccerOutlined';
import DomainOutlinedIcon from '@mui/icons-material/DomainOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import CastForEducationOutlinedIcon from '@mui/icons-material/CastForEducationOutlined';
import FamilyRestroomOutlinedIcon from '@mui/icons-material/FamilyRestroomOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import BookmarkOutlinedIcon from '@mui/icons-material/BookmarkOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import KingBedOutlinedIcon from '@mui/icons-material/KingBedOutlined';
import RestaurantOutlinedIcon from '@mui/icons-material/RestaurantOutlined';
import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import MilitaryTechOutlinedIcon from '@mui/icons-material/MilitaryTechOutlined';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import TheaterComedyOutlinedIcon from '@mui/icons-material/TheaterComedyOutlined';
import ParkOutlinedIcon from '@mui/icons-material/ParkOutlined';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import AltRouteOutlinedIcon from '@mui/icons-material/AltRouteOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MyLocationOutlinedIcon from '@mui/icons-material/MyLocationOutlined';
import WorkspacesOutlinedIcon from '@mui/icons-material/WorkspacesOutlined';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import EditCalendarOutlinedIcon from '@mui/icons-material/EditCalendarOutlined';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';

export interface NavItem {
  label: string;
  to: string;
  icon?: ReactNode;
  /** Short "what's in here" subtitle, shown under the label on card-style menus (e.g. the dashboard's quick-access grid). */
  description?: string;
  /** Portals (shell route folders, not roles) that show this item. Omit to inherit the section's. */
  portals?: Portal[];
  children?: NavItem[];
}

export interface NavSection {
  id: string;
  /** Portals (shell route folders, not roles) that show this section. Omit to show it in every portal. */
  portals?: Portal[];
  label?: string;
  items: NavItem[];
}

export const navigation: NavSection[] = [
  {
    id: 'overview',
    portals: ['administrator'],
    items: [
      { label: 'Dashboard', to: '/administrator/dashboard', icon: <DashboardOutlinedIcon /> },
      { label: 'Enrollment', to: '/administrator/academics/enrollment', icon: <HowToRegOutlinedIcon />, description: 'New admissions' },
      {
        label: 'Promotion',
        to: '/administrator/academics/promotion',
        icon: <TrendingUpOutlinedIcon />,
        description: 'Advance students',
        children: [
          { label: 'Manual Promotion', to: '/administrator/academics/promotion', icon: <TrendingUpOutlinedIcon />, description: 'Promote students by hand' },
          { label: 'Manage Constraints', to: '/administrator/academics/promotion/constraints', icon: <RuleOutlinedIcon />, description: 'Promotion rules' },
        ],
      },
      { label: 'Homework', to: '/administrator/academics/homework', icon: <AutoStoriesOutlinedIcon />, description: 'Assignments & tasks' },
      { label: 'Students', to: '/administrator/students', icon: <GroupsOutlinedIcon />, description: 'Directory & profiles' },
      { label: 'Reports & Analytics', to: '/administrator/reports', icon: <InsightsOutlinedIcon />, description: 'Insights & exports' },
    ],
  },
  {
    id: 'parent',
    portals: ['parent'],
    items: [
      { label: 'My Dashboard', to: '/parent/dashboard', icon: <DashboardOutlinedIcon /> },
      { label: 'My Children', to: '/parent/children', icon: <FamilyRestroomOutlinedIcon /> },
      { label: 'Child Profile', to: '/parent/profile', icon: <PersonOutlineOutlinedIcon /> },
      { label: 'Timetable', to: '/parent/timetable', icon: <CalendarViewWeekOutlinedIcon /> },
      { label: 'Attendance', to: '/parent/attendance', icon: <EventAvailableOutlinedIcon /> },
      { label: 'Homework', to: '/parent/homework', icon: <AutoStoriesOutlinedIcon /> },
      { label: 'Assignments', to: '/parent/assignments', icon: <AssignmentOutlinedIcon /> },
      { label: 'Exams & Results', to: '/parent/exams', icon: <FactCheckOutlinedIcon /> },
      { label: 'Hall Ticket', to: '/parent/hall-ticket', icon: <ConfirmationNumberOutlinedIcon /> },
      { label: 'Performance', to: '/parent/performance', icon: <TrendingUpOutlinedIcon /> },
      { label: 'Fees & Payments', to: '/parent/fees', icon: <PaymentsOutlinedIcon /> },
      { label: 'Transport Details', to: '/parent/transport', icon: <DirectionsBusOutlinedIcon /> },
      { label: 'Medical Records', to: '/parent/medical', icon: <LocalHospitalOutlinedIcon /> },
      { label: 'Announcements', to: '/parent/announcements', icon: <CampaignOutlinedIcon /> },
      { label: 'Teacher Communication', to: '/parent/teacher-communication', icon: <ForumOutlinedIcon /> },
      { label: 'Leave Requests', to: '/parent/leave', icon: <EventBusyOutlinedIcon /> },
    ],
  },
  {
    id: 'principal',
    portals: ['principal'],
    items: [
      { label: 'Dashboard', to: '/principal/dashboard', icon: <DashboardOutlinedIcon /> },
      { label: 'School Overview', to: '/principal/school-overview', icon: <ApartmentOutlinedIcon /> },
      { label: 'Student Summary', to: '/principal/student-summary', icon: <GroupsOutlinedIcon /> },
      { label: 'Faculty Overview', to: '/principal/faculty-overview', icon: <CastForEducationOutlinedIcon /> },
      { label: 'Attendance Overview', to: '/principal/attendance-overview', icon: <EventAvailableOutlinedIcon /> },
      { label: 'Academic Performance', to: '/principal/academic-performance', icon: <TrendingUpOutlinedIcon /> },
      { label: 'Examination Results', to: '/principal/examination-results', icon: <FactCheckOutlinedIcon /> },
      { label: 'Discipline & Behavior', to: '/principal/discipline', icon: <GavelOutlinedIcon /> },
      { label: 'Approvals', to: '/principal/approvals', icon: <TaskAltOutlinedIcon /> },
      { label: 'Parent Issues', to: '/principal/parent-issues', icon: <SupportAgentOutlinedIcon /> },
      { label: 'Staff Management', to: '/principal/staff-management', icon: <BadgeOutlinedIcon /> },
      { label: 'Reports', to: '/principal/reports', icon: <InsightsOutlinedIcon /> },
    ],
  },
  {
    id: 'student-portal',
    portals: ['student'],
    items: [
      { label: 'My Dashboard', to: '/student/dashboard', icon: <DashboardOutlinedIcon /> },
      { label: 'My Profile', to: '/student/profile', icon: <PersonOutlineOutlinedIcon /> },
      { label: 'My Timetable', to: '/student/timetable', icon: <CalendarViewWeekOutlinedIcon /> },
      { label: 'My Subjects', to: '/student/subjects', icon: <MenuBookOutlinedIcon /> },
      { label: 'Attendance', to: '/student/attendance', icon: <EventAvailableOutlinedIcon /> },
      { label: 'Assignments', to: '/student/assignments', icon: <AssignmentOutlinedIcon /> },
      { label: 'Homework', to: '/student/homework', icon: <AutoStoriesOutlinedIcon /> },
      { label: 'Exams & Results', to: '/student/exams', icon: <FactCheckOutlinedIcon /> },
      { label: 'Hall Ticket', to: '/student/hall-ticket', icon: <ConfirmationNumberOutlinedIcon /> },
      { label: 'Performance', to: '/student/performance', icon: <TrendingUpOutlinedIcon /> },
      { label: 'Fees & Payments', to: '/student/fees', icon: <PaymentsOutlinedIcon /> },
      { label: 'Library', to: '/student/library', icon: <LocalLibraryOutlinedIcon /> },
      { label: 'Transport', to: '/student/transport', icon: <DirectionsBusOutlinedIcon /> },
      { label: 'Medical', to: '/student/medical', icon: <LocalHospitalOutlinedIcon /> },
      { label: 'Certificates', to: '/student/certificates', icon: <WorkspacePremiumOutlinedIcon /> },
      { label: 'Messages', to: '/student/messages', icon: <ForumOutlinedIcon /> },
    ],
  },
  {
    id: 'faculty-portal',
    portals: ['faculty'],
    items: [
      { label: 'My Dashboard', to: '/faculty/dashboard', icon: <DashboardOutlinedIcon /> },
      { label: 'My Timetable', to: '/faculty/timetable', icon: <CalendarViewWeekOutlinedIcon /> },
      { label: 'My Class', to: '/faculty/classes', icon: <MenuBookOutlinedIcon /> },
      { label: 'Attendance', to: '/faculty/attendance', icon: <EventAvailableOutlinedIcon /> },
      { label: 'Lesson Plans', to: '/faculty/lesson-plans', icon: <AutoStoriesOutlinedIcon /> },
      { label: 'Assignments', to: '/faculty/assignments', icon: <AssignmentOutlinedIcon /> },
      { label: 'Homework', to: '/faculty/homework', icon: <ChecklistOutlinedIcon /> },
      { label: 'Marks Entry', to: '/faculty/marks', icon: <GradingOutlinedIcon /> },
      { label: 'Class Teacher Remarks', to: '/faculty/remarks', icon: <RateReviewOutlinedIcon /> },
      { label: 'Student Performance', to: '/faculty/performance', icon: <TrendingUpOutlinedIcon /> },
      { label: 'Parent Communication', to: '/faculty/parent-communication', icon: <ForumOutlinedIcon /> },
      { label: 'Leave Management', to: '/faculty/leave', icon: <EventBusyOutlinedIcon /> },
      { label: 'My Profile', to: '/faculty/profile', icon: <PersonOutlineOutlinedIcon /> },
    ],
  },
  {
    id: 'Academics',
    portals: ['administrator'],
    label: 'Academics',
    items: [
      {
        label: 'Academics',
        to: '/administrator/academics',
        icon: <MenuBookOutlinedIcon />,
        description: 'Structure, curriculum & grading',
        // Each is a workspace; its former pages are tabs inside it.
        children: [
          {
            label: 'Academic Structure',
            to: '/administrator/academics/structure',
            icon: <ClassOutlinedIcon />,
            description: 'Academic years, classes, sections & subjects',
          },
          {
            label: 'Curriculum Configuration',
            to: '/administrator/academics/curriculum',
            icon: <ListAltOutlinedIcon />,
            description: 'Class sections & subject allocation',
          },
          {
            label: 'Grade Configuration',
            to: '/administrator/academics/grading',
            icon: <GradingOutlinedIcon />,
            description: 'Grading systems & class assignments',
          },
        ],
      },
    ],
  },
  {
    id: 'timetable',
    portals: ['administrator'],
    label: 'Timetable',
    items: [
      {
        label: 'Timetable',
        to: '/administrator/timetable',
        icon: <CalendarViewWeekOutlinedIcon />,
        description: 'Schedules, generation & substitution',
        children: [
          { label: 'Overview', to: '/administrator/timetable/overview', icon: <DashboardOutlinedIcon />, description: 'Setup status at a glance' },
          { label: 'Bell Schedules', to: '/administrator/timetable/bell-schedules', icon: <ScheduleOutlinedIcon />, description: 'Periods & breaks' },
          { label: 'Student Groups', to: '/administrator/timetable/student-groups', icon: <WorkspacesOutlinedIcon />, description: 'Sections, electives & batches' },
          { label: 'Activities', to: '/administrator/timetable/activities', icon: <EventOutlinedIcon />, description: 'Subject-teacher lessons per week' },
          { label: 'Teachers Availability', to: '/administrator/timetable/teacher-availability', icon: <EventAvailableOutlinedIcon />, description: 'When each teacher can teach' },
          { label: 'Rooms & Resources', to: '/administrator/timetable/rooms-resources', icon: <MeetingRoomOutlinedIcon />, description: 'Classrooms, labs & capacity' },
          { label: 'Constraints', to: '/administrator/timetable/constraints', icon: <RuleOutlinedIcon />, description: 'Rules for the generator' },
          { label: 'Generate Timetable', to: '/administrator/timetable/generate', icon: <AutoAwesomeOutlinedIcon />, description: 'Build timetables automatically' },
          { label: 'Timetable Editor', to: '/administrator/timetable/editor', icon: <EditCalendarOutlinedIcon />, description: 'Adjust periods by hand' },
          { label: 'Substitution', to: '/administrator/timetable/substitution', icon: <SwapHorizOutlinedIcon />, description: 'Cover for absent teachers' },
          { label: 'Time Tables', to: '/administrator/timetable/timetables', icon: <CalendarMonthOutlinedIcon />, description: 'Class & teacher timetables' },
          { label: 'Reports', to: '/administrator/timetable/reports', icon: <SummarizeOutlinedIcon />, description: 'Workload & usage reports' },
        ],
      },
    ],
  },
  {
    id: 'attendance',
    portals: ['administrator'],
    label: 'Attendance',
    items: [
      {
        label: 'Attendance',
        to: '/administrator/attendance',
        icon: <EventAvailableOutlinedIcon />,
        description: 'Daily attendance',
        children: [
          { label: 'Attendance', to: '/administrator/attendance/register', icon: <GridViewOutlinedIcon /> },
          { label: 'Reports', to: '/administrator/attendance/reports', icon: <SummarizeOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'assessment',
    portals: ['administrator'],
    label: 'Assessment',
    items: [
      {
        label: 'Assessment',
        to: '/administrator/assessment',
        icon: <AssignmentOutlinedIcon />,
        description: 'Assessments & marks',
        children: [
          { label: 'Assessments', to: '/administrator/assessment/assessments', icon: <AssignmentOutlinedIcon /> },
          { label: 'Enter Marks', to: '/administrator/assessment/marks', icon: <EditNoteOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'admission',
    portals: ['administrator'],
    label: 'Admission',
    items: [
      {
        label: 'Admission',
        to: '/administrator/admissions',
        icon: <AssignmentIndOutlinedIcon />,
        description: 'Enquiries & intake',
        children: [
          { label: 'Enquiries', to: '/administrator/admissions/enquiries', icon: <ContactSupportOutlinedIcon /> },

          { label: 'Application Form', to: '/administrator/admissions/application-form', icon: <DescriptionOutlinedIcon />, description: 'Online admission form design', },
          { label: 'Applicants', to: '/administrator/admissions/applicants', icon: <PersonAddAltOutlinedIcon /> },
          // { label: 'Application Forms', to: '/administrator/admissions/application-forms', icon: <DescriptionOutlinedIcon /> },
          { label: 'Entrance Test', to: '/administrator/admissions/entrance-test', icon: <QuizOutlinedIcon /> },
          { label: 'Interaction Management', to: '/administrator/admissions/interactions', icon: <ForumOutlinedIcon />, description: 'Tests, interviews & counselling in one place' },
          { label: 'Counselling', to: '/administrator/admissions/counselling', icon: <SupportAgentOutlinedIcon />, description: 'Interview & counselling session' },
          { label: 'Selection', to: '/administrator/admissions/selection', icon: <FactCheckOutlinedIcon /> },
          { label: 'Admission Approval', to: '/administrator/admissions/approval', icon: <TaskAltOutlinedIcon /> },
          { label: 'Fee Payment', to: '/administrator/admissions/fee-payment', icon: <PaymentsOutlinedIcon /> },
          { label: 'Enrollment', to: '/administrator/admissions/enrollment', icon: <HowToRegOutlinedIcon /> },
          { label: 'Waiting List', to: '/administrator/admissions/waiting-list', icon: <HourglassEmptyOutlinedIcon /> },
          { label: 'Admission Reports', to: '/administrator/admissions/reports', icon: <SummarizeOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'examination',
    portals: ['administrator'],
    label: 'Examination',
    items: [
      {
        label: 'Examination',
        to: '/administrator/examination',
        icon: <FactCheckOutlinedIcon />,
        description: 'Exams & results',
        children: [
          { label: 'Dashboard', to: '/administrator/examination/dashboard', icon: <DashboardOutlinedIcon /> },
          { label: 'Exam Setup', to: '/administrator/examination/exams', icon: <TuneOutlinedIcon /> },
          { label: 'Exam Schedule', to: '/administrator/examination/schedule', icon: <EventOutlinedIcon /> },
          { label: 'Question Papers', to: '/administrator/examination/question-papers', icon: <ArticleOutlinedIcon /> },
          { label: 'Exam Attendance', to: '/administrator/examination/attendance', icon: <EventAvailableOutlinedIcon /> },
          { label: 'Marks Entry', to: '/administrator/examination/marks', icon: <EditNoteOutlinedIcon /> },
          { label: 'Results', to: '/administrator/examination/results', icon: <LeaderboardOutlinedIcon /> },
          { label: 'Toppers', to: '/administrator/examination/toppers', icon: <EmojiEventsOutlinedIcon /> },
          { label: 'Report Cards', to: '/administrator/examination/report-cards', icon: <DescriptionOutlinedIcon /> },
          { label: 'Transcripts', to: '/administrator/examination/transcripts', icon: <ReceiptLongOutlinedIcon /> },
          { label: 'Revaluation', to: '/administrator/examination/revaluation', icon: <RateReviewOutlinedIcon /> },
          { label: 'Exam Reports', to: '/administrator/examination/reports', icon: <SummarizeOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'staff',
    portals: ['administrator'],
    label: 'Staff',
    items: [
      {
        label: 'Staff',
        to: '/administrator/staff',
        icon: <BadgeOutlinedIcon />,
        description: 'Directory, attendance & masters',
        children: [
          { label: 'Directory', to: '/administrator/staff/directory', icon: <ContactsOutlinedIcon /> },
          { label: 'Attendance', to: '/administrator/staff/attendance', icon: <EventAvailableOutlinedIcon /> },
          { label: 'Masters', to: '/administrator/staff/masters', icon: <CategoryOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'finance-fees',
    portals: ['administrator'],
    label: 'Finance & Fees',
    items: [
      {
        label: 'Finance & Fees',
        to: '/administrator/fees',
        icon: <PaymentsOutlinedIcon />,
        description: 'Fees & payments',
        children: [
          { label: 'Dashboard', to: '/administrator/fees/dashboard', icon: <DashboardOutlinedIcon /> },
          { label: 'Fee Setup', to: '/administrator/fees/setup', icon: <AccountTreeOutlinedIcon /> },
          { label: 'Student Billing', to: '/administrator/fees/billing', icon: <ReceiptOutlinedIcon /> },
          { label: 'Concessions', to: '/administrator/fees/concessions', icon: <LocalOfferOutlinedIcon /> },
          { label: 'Reports', to: '/administrator/fees/reports', icon: <AssessmentOutlinedIcon /> },
          { label: 'Finance', to: '/administrator/fees/finance', icon: <AccountBalanceWalletOutlinedIcon /> },
          { label: 'Payment Accounts', to: '/administrator/fees/payment-accounts', icon: <AccountBalanceOutlinedIcon /> },
          { label: 'Settings', to: '/administrator/fees/settings', icon: <SettingsOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'library',
    portals: ['administrator'],
    label: 'Library',
    items: [
      {
        label: 'Library',
        to: '/administrator/library',
        icon: <LocalLibraryOutlinedIcon />,
        description: 'Books & members',
        children: [
          { label: 'Dashboard', to: '/administrator/library/dashboard', icon: <DashboardOutlinedIcon /> },
          { label: 'Book Management', to: '/administrator/library/books', icon: <MenuBookOutlinedIcon /> },
          { label: 'Categories', to: '/administrator/library/categories', icon: <CategoryOutlinedIcon /> },
          { label: 'Authors / Publishers', to: '/administrator/library/contributors', icon: <PeopleAltOutlinedIcon /> },
          { label: 'Issue Books', to: '/administrator/library/issue-books', icon: <AssignmentTurnedInOutlinedIcon /> },
          { label: 'Return Books', to: '/administrator/library/return-books', icon: <AssignmentReturnOutlinedIcon /> },
          { label: 'Reservations', to: '/administrator/library/reservations', icon: <BookmarkOutlinedIcon /> },
          { label: 'Fines', to: '/administrator/library/fines', icon: <PaidOutlinedIcon /> },
          { label: 'Members', to: '/administrator/library/members', icon: <GroupsOutlinedIcon /> },
          { label: 'Library Inventory', to: '/administrator/library/inventory', icon: <Inventory2OutlinedIcon /> },
          { label: 'Library Reports', to: '/administrator/library/reports', icon: <SummarizeOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'hostel-boarding',
    portals: ['administrator'],
    label: 'Hostel & Boarding',
    items: [
      {
        label: 'Hostel & Boarding',
        to: '/administrator/hostel',
        icon: <HotelOutlinedIcon />,
        description: 'Rooms & allocation',
        children: [
          { label: 'Dashboard', to: '/administrator/hostel/dashboard', icon: <DashboardOutlinedIcon /> },
          { label: 'Hostel Blocks', to: '/administrator/hostel/blocks', icon: <ApartmentOutlinedIcon /> },
          { label: 'Rooms', to: '/administrator/hostel/rooms', icon: <MeetingRoomOutlinedIcon /> },
          { label: 'Beds', to: '/administrator/hostel/beds', icon: <KingBedOutlinedIcon /> },
          { label: 'Student Allocation', to: '/administrator/hostel/allocation', icon: <AssignmentIndOutlinedIcon /> },
          { label: 'Hostel Attendance', to: '/administrator/hostel/attendance', icon: <EventAvailableOutlinedIcon /> },
          { label: 'Meal Management', to: '/administrator/hostel/meals', icon: <RestaurantOutlinedIcon /> },
          { label: 'Wardens / Staff', to: '/administrator/hostel/staff', icon: <BadgeOutlinedIcon /> },
          { label: 'Visitor Management', to: '/administrator/hostel/visitors', icon: <PersonPinOutlinedIcon /> },
          { label: 'Complaints', to: '/administrator/hostel/complaints', icon: <ReportProblemOutlinedIcon /> },
          { label: 'Maintenance', to: '/administrator/hostel/maintenance', icon: <BuildOutlinedIcon /> },
          { label: 'Hostel Reports', to: '/administrator/hostel/reports', icon: <SummarizeOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'health-medical',
    portals: ['administrator'],
    label: 'Hospital & Medical',
    items: [
      {
        label: 'Hospital & Medical',
        to: '/administrator/health',
        icon: <LocalHospitalOutlinedIcon />,
        description: 'Records & incidents',
        children: [
          { label: 'Medical Records', to: '/administrator/health/records', icon: <DescriptionOutlinedIcon /> },
          { label: 'Incidents', to: '/administrator/health/incidents', icon: <ReportProblemOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'sports',
    portals: ['administrator'],
    label: 'Sports',
    items: [
      {
        label: 'Sports',
        to: '/administrator/sports',
        icon: <SportsSoccerOutlinedIcon />,
        description: 'Teams & fixtures',
        children: [
          { label: 'Dashboard', to: '/administrator/sports/dashboard', icon: <DashboardOutlinedIcon /> },
          { label: 'Sports / Games', to: '/administrator/sports/catalogue', icon: <CategoryOutlinedIcon /> },
          { label: 'Teams', to: '/administrator/sports/teams', icon: <GroupsOutlinedIcon /> },
          { label: 'Players', to: '/administrator/sports/players', icon: <PersonOutlineOutlinedIcon /> },
          { label: 'Coaches', to: '/administrator/sports/coaches', icon: <SupportAgentOutlinedIcon /> },
          { label: 'Training Schedules', to: '/administrator/sports/training-schedules', icon: <ScheduleOutlinedIcon /> },
          { label: 'Matches & Fixtures', to: '/administrator/sports/matches', icon: <EventOutlinedIcon /> },
          { label: 'Attendance', to: '/administrator/sports/attendance', icon: <EventAvailableOutlinedIcon /> },
          { label: 'Player Performance', to: '/administrator/sports/performance', icon: <TrendingUpOutlinedIcon /> },
          { label: 'Tournaments', to: '/administrator/sports/tournaments', icon: <EmojiEventsOutlinedIcon /> },
          { label: 'Achievements', to: '/administrator/sports/achievements', icon: <MilitaryTechOutlinedIcon /> },
          { label: 'Sports Facilities', to: '/administrator/sports/facilities', icon: <DomainOutlinedIcon /> },
          { label: 'Sports Reports', to: '/administrator/sports/reports', icon: <SummarizeOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'transport',
    portals: ['administrator'],
    label: 'Transport',
    items: [
      {
        label: 'Transport',
        to: '/administrator/transport',
        icon: <DirectionsBusOutlinedIcon />,
        description: 'Routes & vehicles',
        children: [
          { label: 'Dashboard', to: '/administrator/transport/dashboard', icon: <DashboardOutlinedIcon /> },
          { label: 'Vehicles', to: '/administrator/transport/vehicles', icon: <LocalShippingOutlinedIcon /> },
          { label: 'Drivers', to: '/administrator/transport/drivers', icon: <BadgeOutlinedIcon /> },
          { label: 'Routes', to: '/administrator/transport/routes', icon: <AltRouteOutlinedIcon /> },
          { label: 'Stops', to: '/administrator/transport/stops', icon: <LocationOnOutlinedIcon /> },
          { label: 'Student Allocation', to: '/administrator/transport/allocation', icon: <AssignmentIndOutlinedIcon /> },
          { label: 'Transport Attendance', to: '/administrator/transport/attendance', icon: <EventAvailableOutlinedIcon /> },
          { label: 'Pickup/Drop Tracking', to: '/administrator/transport/tracking', icon: <MyLocationOutlinedIcon /> },
          { label: 'Transport Fees', to: '/administrator/transport/fees', icon: <PaymentsOutlinedIcon /> },
          { label: 'Vehicle Maintenance', to: '/administrator/transport/maintenance', icon: <BuildOutlinedIcon /> },
          { label: 'Route Optimization', to: '/administrator/transport/optimization', icon: <TuneOutlinedIcon /> },
          { label: 'Alerts & Notifications', to: '/administrator/transport/alerts', icon: <NotificationsActiveOutlinedIcon /> },
          { label: 'Transport Reports', to: '/administrator/transport/reports', icon: <SummarizeOutlinedIcon /> },
          { label: 'Expenses', to: '/administrator/transport/expenses', icon: <AccountBalanceWalletOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'facility-campus',
    portals: ['administrator'],
    label: 'Facility & Campus',
    items: [
      {
        label: 'Facility & Campus',
        to: '/administrator/facility',
        icon: <DomainOutlinedIcon />,
        description: 'Buildings & bookings',
        children: [
          { label: 'Dashboard', to: '/administrator/facility/dashboard', icon: <DashboardOutlinedIcon /> },
          { label: 'Buildings', to: '/administrator/facility/buildings', icon: <ApartmentOutlinedIcon /> },
          { label: 'Classrooms', to: '/administrator/facility/classrooms', icon: <ClassOutlinedIcon /> },
          { label: 'Labs', to: '/administrator/facility/labs', icon: <ScienceOutlinedIcon /> },
          { label: 'Auditorium', to: '/administrator/facility/auditorium', icon: <TheaterComedyOutlinedIcon /> },
          { label: 'Playground', to: '/administrator/facility/playground', icon: <ParkOutlinedIcon /> },
          { label: 'Meeting Rooms', to: '/administrator/facility/meeting-rooms', icon: <MeetingRoomOutlinedIcon /> },
          { label: 'Facility Booking', to: '/administrator/facility/bookings', icon: <EventOutlinedIcon /> },
          { label: 'Maintenance', to: '/administrator/facility/maintenance', icon: <BuildOutlinedIcon /> },
          { label: 'Cleaning', to: '/administrator/facility/cleaning', icon: <CleaningServicesOutlinedIcon /> },
          { label: 'Security', to: '/administrator/facility/security', icon: <SecurityOutlinedIcon /> },
          { label: 'Campus Maps', to: '/administrator/facility/maps', icon: <MapOutlinedIcon /> },
          { label: 'Facility Reports', to: '/administrator/facility/reports', icon: <SummarizeOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'communication',
    portals: ['administrator'],
    label: 'Communication',
    items: [
      {
        label: 'Communication',
        to: '/administrator/communication',
        icon: <CampaignOutlinedIcon />,
        description: 'Announcements & alerts',
        children: [
          { label: 'Dashboard', to: '/administrator/communication/dashboard', icon: <DashboardOutlinedIcon /> },
          { label: 'Announcements', to: '/administrator/communication/announcements', icon: <CampaignOutlinedIcon /> },
          { label: 'Notices / Circulars', to: '/administrator/communication/notices', icon: <ArticleOutlinedIcon /> },
          { label: 'Email', to: '/administrator/communication/email', icon: <EmailOutlinedIcon /> },
          { label: 'SMS', to: '/administrator/communication/sms', icon: <SmsOutlinedIcon /> },
          { label: 'Push Notifications', to: '/administrator/communication/push', icon: <NotificationsActiveOutlinedIcon /> },
          { label: 'Parent Communication', to: '/administrator/communication/parent', icon: <ForumOutlinedIcon /> },
          { label: 'Faculty Communication', to: '/administrator/communication/faculty', icon: <ForumOutlinedIcon /> },
          { label: 'Student Communication', to: '/administrator/communication/student', icon: <ForumOutlinedIcon /> },
          { label: 'Event Calendar', to: '/administrator/communication/events', icon: <EventOutlinedIcon /> },
          { label: 'Feedback', to: '/administrator/communication/feedback', icon: <FeedbackOutlinedIcon /> },
          { label: 'Emergency Alerts', to: '/administrator/communication/alerts', icon: <ReportProblemOutlinedIcon /> },
          { label: 'Message Templates', to: '/administrator/communication/templates', icon: <ArticleOutlinedIcon /> },
          { label: 'Communication Reports', to: '/administrator/communication/reports', icon: <SummarizeOutlinedIcon /> },
        ],
      },
    ],
  },
  {
    id: 'administration',
    portals: ['administrator'],
    label: 'Administration',
    items: [
      {
        label: 'School',
        to: '/administrator/school',
        icon: <ApartmentOutlinedIcon />,
        description: 'Schools, contacts, calendar and branding',
      },
    //   {
    //     label: 'Education Boards',
    //     to: '/administrator/education-boards',
    //     icon: <AccountBalanceOutlinedIcon />,
    //     description: 'Boards followed, per academic year',
    //   },
      {
        label: 'Global Settings',
        to: '/administrator/global-settings',
        icon: <TuneOutlinedIcon />,
        description: 'Regional, date and time settings, key formats and letterheads',
      },
      {
        label: 'Document Permissions',
        to: '/administrator/settings/document-permissions',
        icon: <AdminPanelSettingsOutlinedIcon />,
        description: 'What each role may do with each document type',
      },
      {
        label: 'Audit Logs',
        to: '/administrator/audit-logs',
        icon: <HistoryOutlinedIcon />,
        description: 'Who changed what, and when, across every module',
      },
    ],
  },
];

const shownIn = (portal: Portal, portals?: Portal[]) => !portals || portals.includes(portal);

function filterItems(items: NavItem[], portal: Portal): NavItem[] {
  return items
    .filter((item) => shownIn(portal, item.portals))
    .map((item) => (item.children ? { ...item, children: filterItems(item.children, portal) } : item));
}

/**
 * The built-in navigation sections (and items) of `portal`: the sidebar in sample data only.
 * Signed in with Fabrica's menus loaded, only those menus show (see `useNavigation`).
 */
export function navigationForPortal(portal: Portal): NavSection[] {
  return navigation
    .filter((section) => shownIn(portal, section.portals))
    .map((section) => ({ ...section, items: filterItems(section.items, portal) }));
}

export const brand = {
  name: 'Camptain',
  icon: <SchoolOutlinedIcon />,
};
